export default __webpack_public_path__ + "static/media/AF_WERFEN_BN_NEG_RGB.3f3146b8.png";